import { Component, ViewChild, Output,EventEmitter } from '@angular/core';
import { AlertService } from '../../_services/alert.service';
import { AuthenticationService } from '../../_services/authentication.service';
import {User} from '../../_models/user';
import { SettingsService } from "../../_services/settings.service";

@Component({
    selector: 'login',
    templateUrl: 'login.html'
})

export class LoginComponent {

    model: User = new User();
    

    @Output()
    loggedin: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(public auth: AuthenticationService,
        private alertService: AlertService, public sett:SettingsService) {

    }


    login() {
        this.sett.pageSettings.running = true;
        if (this.auth.loginHelper.isRegister) {
            this.register();
        }
        else {
            this.auth.login(this.model.username, this.model.password)
                .subscribe(
                data => {
                    this.auth.loginHelper.attempts = 0;
                    let accesstoken = this.auth.user.token = data['access_token'];
                    this.auth.userInfo().subscribe(data => {
                        this.auth.user = new User(data);
                        this.auth.user.password = this.model.password;
                        this.auth.user.token = accesstoken;
                        localStorage.setItem("currentUser", JSON.stringify(this.auth.user));
                        this.auth.user.loggedin = true;
                        this.loggedin.emit(true);
                        this.sett.pageSettings.running = false;

                    }, error => {
                        this.alertService.error(error);
                        this.auth.user.loggedin = false;
                        this.sett.pageSettings.running = false;
                    })
                    this.auth.loginHelper.present = false;
                },
                error => {
                    this.auth.loginHelper.attempts++;
                    this.alertService.error(error.error.error_description);
                    this.sett.pageSettings.running = false;
                });
        }
    }

    register() {
      
      this.model.email = this.model.username;      
        this.sett.pageSettings.running = true;
        this.auth.register(this.model)
            .subscribe(
            data => {
                this.auth.loginHelper.isRegister = false;
                //this.login();
                this.auth.loginHelper.present = false;
                this.sett.pageSettings.running = false;
                this.alertService.success("New user created");
            },
            error => {
              
              this.alertService.error(this.auth.niceerror(error));
                this.sett.pageSettings.running = false;
            });
    }
    cancel() {
      this.auth.loginHelper.present = false;
    }
    forgot() {
        this.auth.user.email = this.model.username;
        this.auth.reset().subscribe(data => {
            this.auth.loginHelper.attempts = 0;
            this.alertService.success("Password reset process in hand, please check your email for a reset link");
        }, error => {
            this.alertService.error("Sorry we don't seem to be able to reset the password from this user");
        });
    }
    resetPass() {
        this.auth.user.newPassword = this.model.password;
        this.auth.user.confirmPassword = this.model.confirmPassword;
        if (this.model.password != this.model.confirmPassword) {
            this.alertService.error("Passwords don't match.");
        }
        else {
            this.auth.doReset().subscribe(data => {
                this.alertService.success("Password Reset, Please login again");
                this.auth.user.newPassword = "";
                this.auth.user.password = "";
                this.auth.user.confirmPassword = "";
            this.auth.loginHelper.reset = false;
            this.auth.loginHelper.present = true;
        }, error => {
            this.alertService.error("Password reset failed, please check your email address and try again.");
            this.auth.loginHelper.attempts = 2;
            this.auth.loginHelper.reset = false;
            this.auth.loginHelper.present = true;
            });
        }
        
    }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/components/login/login.ts